import { React, useEffect } from "react";
import { loginRequest, protectedResources } from "../authConfig";
import { useMsal } from "@azure/msal-react";
import { useRecordLoginMutation } from "../services/ClientService";

export const AuthenticatedPage = (props) => {
  const { instance, accounts } = useMsal();
  const [recordLogin] = useRecordLoginMutation();

  // Record a sign-in once per browser tab session (sessionStorage, not localStorage, so a
  // fresh tab/window counts as a new sign-in but a page refresh within the same tab doesn't).
  useEffect(() => {
    if (sessionStorage.getItem("loginRecorded")) return;
    sessionStorage.setItem("loginRecorded", "1");
    recordLogin();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const refreshToken = () => {
    instance
      .acquireTokenSilent({
        account: accounts[0],
        scopes: [...protectedResources.api.scopes.read],
      })
      .then((response) => {
        localStorage.setItem("token", response?.accessToken);
      })
      .catch((e) => {
        instance
          .loginRedirect(loginRequest)
          .catch((error) => console.log(error));
      });
  };
  useEffect(() => {
    const intervalId = setInterval(refreshToken, 3600 * 1000);

    return () => {
      clearInterval(intervalId);
    };
  }, []);

  return <>{props.children}</>;
};
